import React, { useEffect, useMemo, useState } from "react";
import "../../style.css";
import "./property-single.css";
import "../../responsive.css";
import "../../app-overrides.css";
import mainImage from "../../assets/main.jpg";
import additionalImage from "../../assets/property-main-test.jpg";
import additionalRoomImage from "../../assets/property-room-test.jpg";
import thumb1Image from "../../assets/thumb1.jpg";
import thumb2Image from "../../assets/thumb2.jpg";
import agentImage from "../../assets/agent.jpg";

const property = {

  code: "AP0099",

  title:

    "Apartamento: 2 dormitórios, 39 m², R$ 129.000 - Sapucaia do Sul, Pasqualini",

  communityName: "Residencial Nicolau Kuhn",

  type: "Apartamento",

  price: 129000,

  features: {
    areaM2: { enabled: true, value: 39 },
    bedrooms: { enabled: true, value: 2 },
    bathrooms: { enabled: true, value: 1 },
    suites: { enabled: false, value: 0 },
    garages: { enabled: true, value: 1 },
    landDimensions: { enabled: false, value: "" },
    landAreaM2: { enabled: false, value: 0 },
    aboveStreet: { enabled: false, value: false },
    noFlooding: { enabled: false, value: false },
    elevator: { enabled: false, value: false },
    floor: { enabled: true, value: "Térreo" },
    dimensionsAXL: { enabled: false, value: "" },
    pond: { enabled: false, value: false },
    shed: { enabled: false, value: false },
  },

  district: "Pasqualini",

  city: "Sapucaia do Sul",

  state: "RS",

  condominium: "R$ 185",

  iptu: "R$ 470",

  address: "Bloco 23 - Condomínio Nicolau Kuhn",

  images: [

    {

      src: mainImage,

      alt: "Imagem principal do imóvel",

    },

    {

      src: thumb1Image,

      alt: "Vista do condomínio",

    },

    {

      src: thumb2Image,

      alt: "Área interna do imóvel",

    },

    {

      src: additionalImage,

      alt: "Área de serviço do imóvel",

    },

    {

      src: additionalRoomImage,

      alt: "Dormitório do imóvel",

    },

  ],

  description: [

    "Apartamento com 2 dormitórios à venda, 39 m² – Pasqualini – Sapucaia do Sul/RS",

    "Agora você consegue comprar!",

    "Apartamento térreo, localizado no Bloco 23 do Condomínio Nicolau Kuhn, no bairro Pasqualini.",

    "O imóvel conta com 2 dormitórios, sala, cozinha, banheiro e vaga para estacionamento, sendo uma ótima opção para quem busca praticidade e segurança.",

    "O condomínio oferece:\n- portaria 24 horas;\n- playground;\n- quadra esportiva;\n- salão de festas;\n- áreas verdes proporcionando uma estrutura completa para toda a família.",

    "E o melhor: possibilidade de 100% de financiamento bancário, conforme análise e aprovação da instituição financeira.",

    "💰 Valor: R$ 129.000",

    "Entre em contato conosco para consultar as condições de financiamento e agendar uma visita.",

  ],

  amenities: [],

  communityFeatures: [

    "Playground",

    "Quadra Poliesportiva",

    "Salão de Festas",

    "Espaço Gourmet",

    "Segurança 24h",

    "Câmeras de Segurança",

  ],

};

const propertyTypeCategories = {
  terreno: "land",
  casa: "residential",
  apartamento: "residential",
  kitnet: "residential",
  quitinete: "residential",
  "sala comercial": "commercial",
  sitio: "rural",
};

const propertyFeatureDefinitions = {
  land: [
    { key: "landDimensions", label: "Medidas do terreno", icon: "axl", valueOnly: true },
    { key: "landAreaM2", label: "Área do terreno", icon: "meters", unit: "m²" },
    { key: "aboveStreet", label: "Mais alto que a rua", icon: "terrain", positiveOnly: true },
    { key: "noFlooding", label: "Sem alagamento", icon: "flood", positiveOnly: true },
  ],
  residential: [
    { key: "areaM2", label: "Área", icon: "meters", unit: "m²" },
    { key: "bedrooms", label: "Dormitórios", icon: "bed", unit: "dormitório", plural: "dormitórios", hideZero: true },
    { key: "bathrooms", label: "Banheiros", icon: "toilet", unit: "banheiro", plural: "banheiros", hideZero: true },
    { key: "suites", label: "Suítes", icon: "bathtub", unit: "suíte", plural: "suítes", hideZero: true },
    { key: "garages", label: "Vagas", icon: "car", unit: "vaga", plural: "vagas", hideZero: true },
    { key: "landAreaM2", label: "Metragem do terreno", icon: "meters", unit: "m²" },
    { key: "noFlooding", label: "Sem alagamento", icon: "flood", positiveOnly: true },
    { key: "elevator", label: "Elevador", icon: "elevator", positiveOnly: true },
    { key: "floor", label: "Andar", icon: "floor", valueOnly: true },
  ],
  commercial: [
    { key: "areaM2", label: "Área", icon: "meters", unit: "m²" },
    { key: "floor", label: "Andar", icon: "floor", valueOnly: true },
    { key: "elevator", label: "Elevador", icon: "elevator", positiveOnly: true },
    { key: "bathrooms", label: "Banheiros", icon: "toilet", unit: "banheiro", plural: "banheiros", hideZero: true },
  ],
  rural: [
    { key: "landAreaM2", label: "Área do sítio", icon: "meters", unit: "m²" },
    { key: "noFlooding", label: "Sem alagamento", icon: "flood", positiveOnly: true },
    { key: "dimensionsAXL", label: "A × L", icon: "axl", valueOnly: true },
    { key: "pond", label: "Açude", icon: "pool", positiveOnly: true },
    { key: "shed", label: "Galpão", icon: "home", positiveOnly: true },
    { key: "landDimensions", label: "Medidas do terreno", icon: "axl", valueOnly: true },
  ],
};

// Mostra somente os atributos ativos deste imóvel; os demais ficam ocultos.
const previewAllFeatureIcons = false;

function getVisiblePropertyFeatures(propertyData) {
  const normalizedType = (propertyData.type || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
  const category = propertyTypeCategories[normalizedType];
  const definitions = previewAllFeatureIcons
    ? [...new Map(Object.values(propertyFeatureDefinitions).flat().map((item) => [item.key, item])).values()]
    : propertyFeatureDefinitions[category] || [];

  return definitions.flatMap((definition) => {
    const field = propertyData.features?.[definition.key];
    if (!field?.enabled || field.value === null || field.value === "") return [];
    if (definition.positiveOnly && field.value !== true) return [];
    if (definition.hideZero && Number(field.value) === 0) return [];

    let text = definition.label;
    if (definition.unit === "m²") {
      text = `${field.value} m²`;
    } else if (definition.unit) {
      text = `${field.value} ${Number(field.value) === 1 ? definition.unit : definition.plural}`;
    } else if (definition.valueOnly) {
      text = field.value;
    } else if (!definition.positiveOnly) {
      text = `${definition.label}: ${field.value}`;
    }

    return [{ ...definition, text }];
  });
}

function PropertyFeatureIcon({ name }) {
  if (name === "axl") {
    return (
      <span
        className="property-feature-axl"
        style={{ "--axl-icon-url": `url("${process.env.PUBLIC_URL}/images/axl-icon-7633175a44.svg")` }}
        aria-hidden="true"
      />
    );
  }

  if (name === "meters") {
    return (
      <span
        className="property-feature-meters"
        style={{ "--meters-icon-url": `url("${process.env.PUBLIC_URL}/images/meters-icon-3d329f8c13.svg")` }}
        aria-hidden="true"
      />
    );
  }

  if (name === "floor") {
    return (
      <span
        className="property-feature-floor"
        style={{ "--floor-icon-url": `url("${process.env.PUBLIC_URL}/images/floor-icon-a308f99ab3.svg")` }}
        aria-hidden="true"
      />
    );
  }

  if (name === "flood") {
    return (
      <span
        className="property-feature-flood"
        style={{ "--flood-icon-url": `url("${process.env.PUBLIC_URL}/images/no-flooding-icon-8deada94bd.svg")` }}
        aria-hidden="true"
      />
    );
  }

  if (name === "elevator") {
    return (
      <span
        className="property-feature-elevator"
        style={{ "--elevator-icon-url": `url("${process.env.PUBLIC_URL}/images/elevator-icon-c2beceef1d.svg")` }}
        aria-hidden="true"
      />
    );
  }

  if (name === "toilet") {
    return (
      <span
        className="property-feature-toilet"
        style={{ "--toilet-icon-url": `url("${process.env.PUBLIC_URL}/images/toilet-icon-547a89c6c5.png")` }}
        aria-hidden="true"
      />
    );
  }

  return <span className={`icon-${name}`} aria-hidden="true" />;
}

const whatsappNumber = "555199554873";

const whatsappUrl = `https\://wa.me/${whatsappNumber}`;

function formatPrice(value) {

  return new Intl.NumberFormat("pt-BR", {

    style: "currency",

    currency: "BRL",

    maximumFractionDigits: 0,

  }).format(value);

}

function PropertySingle() {

  const [activeImage, setActiveImage] = useState(0);

  const [imageViewerOpen, setImageViewerOpen] = useState(false);

  const [showForm, setShowForm] = useState(false);

  const [toast, setToast] = useState(false);

  const currentImage = useMemo(

    () => property.images[activeImage],

    [activeImage]

  );

  const visiblePropertyFeatures = getVisiblePropertyFeatures(property);

  const nextImage = () => {

    setActiveImage(

      (current) => (current + 1) % property.images.length

    );

  };

  const previousImage = () => {

    setActiveImage((current) =>

      current === 0 ? property.images.length - 1 : current - 1

    );

  };

  useEffect(() => {
    if (!imageViewerOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    const handleViewerKeyDown = (event) => {
      if (event.key === "Escape") setImageViewerOpen(false);
      if (event.key === "ArrowRight") nextImage();
      if (event.key === "ArrowLeft") previousImage();
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleViewerKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleViewerKeyDown);
    };
  }, [imageViewerOpen]);

  const copyLink = async () => {

    try {

      await navigator.clipboard.writeText(window.location.href);

      setToast(true);

      window.setTimeout(() => {

        setToast(false);

      }, 2200);

    } catch {

      // Clipboard pode ser bloqueado pelo navegador.

    }

  };

  const submitForm = (event) => {

    event.preventDefault();

    setShowForm(false);

  };

  return (

    <div

      className="app"

      style={{

        "--primary-color": "#367f68",

        "--font-family": "Inter, sans-serif",

      }}

    >

      

      <main className="property-details-section">

        <div className="container">

          <div

            className="property-code"

            style={{

              display: "block",

              fontSize: "13px",

              color: "#6c757d",

              marginBottom: "4px",

            }}

          >

            Imóvel código {property.code}

          </div>

          <div className="property-header-social-media">

            <div>

              <h1 className="property-title">

                {property.title}

              </h1>

              <p className="community-title fs-5">

                {property.communityName}

              </p>

            </div>

            <div className="property-actions">

              <div className="share-section">

                <span className="action-label">

                  Compartilhar

                </span>

                <div className="action-buttons">

                  <a

                    className="btn-share whatsapp"

                    href={`${whatsappUrl}?text=${encodeURIComponent(

                      property.title

                    )}`}

                    target="_blank"

                    rel="noreferrer"

                    title="Compartilhar no WhatsApp"

                  >

                    <span className="icon-whatsapp" />

                  </a>

                  <button

                    className="btn-share copy-link"

                    onClick={copyLink}

                    title="Copiar link"

                  >

                    <span className="icon-link" />

                  </button>

                </div>

              </div>

              <div className="social-section">

                <span className="action-label">

                  Redes Sociais

                </span>

                <div className="action-buttons">

                  <a

                    href="#"

                    className="btn-social instagram"

                    title="Instagram"

                  >

                    <span className="icon-instagram" />

                  </a>

                </div>

              </div>

            </div>

          </div>

          <div

            className={`toast-notification ${toast ? "show" : ""

              }`}

          >

            <span>✓</span>

            <span>Link copiado com sucesso!</span>

          </div>

          <div className="property-content">

            <div className="property-gallery">

              <div className="main-image">

                <img

                  src={currentImage.src}

                  alt={currentImage.alt}

                  id="mainImage"

                  className="main-image-clickable"

                  role="button"

                  tabIndex={0}

                  aria-label="Ampliar imagem do imóvel"

                  onClick={() => setImageViewerOpen(true)}

                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      setImageViewerOpen(true);
                    }
                  }}

                />

                <button

                  className="nav-arrow nav-arrow-left"

                  onClick={previousImage}

                  aria-label="Imagem anterior"

                >

                  <svg

                    width="24"

                    height="24"

                    viewBox="0 0 24 24"

                    fill="none"

                  >

                    <path

                      d="M15 18l-6-6 6-6"

                      stroke="currentColor"

                      strokeWidth="2"

                      strokeLinecap="round"

                      strokeLinejoin="round"

                    />

                  </svg>

                </button>

                <button

                  className="nav-arrow nav-arrow-right"

                  onClick={nextImage}

                  aria-label="Próxima imagem"

                >

                  <svg

                    width="24"

                    height="24"

                    viewBox="0 0 24 24"

                    fill="none"

                  >

                    <path

                      d="M9 18l6-6-6-6"

                      stroke="currentColor"

                      strokeWidth="2"

                      strokeLinecap="round"

                      strokeLinejoin="round"

                    />

                  </svg>

                </button>

              </div>

              <div className="thumbnail-grid">

                {property.images.slice(1, 4).map((image, visibleIndex) => {
                  const index = visibleIndex + 1;
                  const isMoreTile = visibleIndex === 2;

                  return (

                  <button

                    key={image.src}

                    className={`thumbnail ${isMoreTile ? "thumbnail-more" : ""} ${index === activeImage ? "active" : ""

                      }`}

                    onClick={() => {
                      setActiveImage(index);
                      setImageViewerOpen(true);
                    }}

                    aria-label={isMoreTile ? `Ver todas as ${property.images.length} imagens` : `Abrir imagem ${index + 1} no visualizador`}

                  >

                    <img

                      src={image.src}

                      alt={image.alt}

                    />

                    {isMoreTile && (
                      <span className="overlay">
                        <svg className="thumbnail-camera-icon" viewBox="0 0 24 24" aria-hidden="true">
                          <path d="M14 4h-4l-1.5 2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3.5L14 4Z" />
                          <circle cx="12" cy="13" r="3.5" />
                        </svg>
                        <span>Ver todas ({property.images.length})</span>
                      </span>
                    )}

                  </button>

                  );
                })}

              </div>

            </div>

            <div className="property-info-wrapper">

              <div className="property-main-info">

                <div className="property-description">

                  <div className="negotiation-facilities">

                    <h2>Facilidades de Negociação</h2>

                    <div className="negotiation-badges">

                      <div className="badge">

                        <span className="icon-check-circle" />

                        Aceita financiamento bancário

                      </div>

                      <div className="badge">

                        <span className="icon-refresh" />

                        Avalia veículo

                      </div>

                      <div className="badge">

                        <span className="icon-home" />

                        Avalia imóvel de menor valor

                      </div>

                    </div>

                  </div>

                  <h2>Sobre o Imóvel</h2>

                  {property.description.map((paragraph) => (

                    <p key={paragraph}>

                      {paragraph

                        .split("\n")

                        .map((line, index) => (

                          <React.Fragment key={line}>

                            {index > 0 && <br />}

                            {line}

                          </React.Fragment>

                        ))}

                    </p>

                  ))}

                  <div className="property-amenities">

                    <h4>Diferenciais do Imóvel</h4>

                    <ul className="amenities-list">

                      <li>

                        <span className="icon-check" />

                        Apartamento térreo

                      </li>

                      <li>

                        <span className="icon-check" />

                        Vaga para estacionamento

                      </li>

                      <li>

                        <span className="icon-check" />

                        Possibilidade de financiamento

                      </li>

                    </ul>

                  </div>

                  <div className="community-structure">

                    <h4>Estrutura do Condomínio</h4>

                    <ul className="community-features-list">

                      {property.communityFeatures.map(

                        (feature) => (

                          <li key={feature}>

                            <span className="icon-check" />

                            {feature}

                          </li>

                        )

                      )}

                    </ul>

                  </div>

                  <div className="location-info">

                    <div className="address">

                      <span className="icon-map-marker" />

                      {property.address} -{" "}

                      {property.district},{" "}

                      {property.city}/{property.state}

                    </div>

                    <div className="location-details">

                      <div className="detail-item">

                        <strong>Bairro:</strong>{" "}

                        {property.district}

                      </div>

                      <div className="detail-item">

                        <strong>Cidade:</strong>{" "}

                        {property.city}

                      </div>

                      <div className="detail-item">

                        <strong>Estado:</strong>{" "}

                        {property.state}

                      </div>

                    </div>

                  </div>

                </div>

              </div>

              <aside className="property-info-sidebar">

                <div className="price-card">

                  <div className="price-main">

                    <span className="price-type">

                      Venda

                    </span>

                    <div className="price-container">

                      <span className="price-value">

                        {formatPrice(property.price)}

                      </span>

                    </div>

                  </div>

                  <div className="price-details">

                    <span>

                      Condomínio {property.condominium}

                    </span>

                    <span>

                      IPTU {property.iptu}

                    </span>

                  </div>

                </div>

                <div className="features-card">
                  {visiblePropertyFeatures.map((feature) => (
                    <div className="feature-item" key={feature.key}>
                      <PropertyFeatureIcon name={feature.icon} />
                      <div>
                        <div className="feature-label">{feature.text}</div>
                      </div>
                    </div>
                  ))}
                </div>

                <div

                  className={`agent-contact-card-wrapper ${showForm ? "flipped" : ""

                    }`}

                >

                  <div className="agent-contact-card">

                    <div className="card-front">

                      <div className="agent-header">

                        <div className="agent-photo agent-initials">

                          <img

                            src={agentImage}

                            alt="Dalmo Souza"

                            className="agent-avatar-img"

                          />

                        </div>

                        <div className="agent-info">

                          <h3 className="agent-name">

                            Dalmo Souza - Corretor - CRECI 54873

                          </h3>

                          <p className="agent-role">

                            Gestor deste Imóvel

                          </p>

                        </div>

                      </div>

                      <div className="agent-cta">

                        <button

                          className="btn btn-primary"

                          onClick={() => setShowForm(true)}

                        >

                          Quero mais informações

                        </button>

                      </div>

                      <div className="agent-social">

                        <span className="social-label">

                          Redes sociais

                        </span>

                        <ul className="social-list">

                          <li>

                            <a

                              href={whatsappUrl}

                              className="social-link whatsapp"

                              target="_blank"

                              rel="noreferrer"

                            >

                              <span className="icon-whatsapp" />

                            </a>

                          </li>

                          <li>

                            <a

                              href="#"

                              className="social-link instagram"

                            >

                              <span className="icon-instagram" />

                            </a>

                          </li>

                        </ul>

                      </div>

                    </div>

                    <div className="card-back">

                      <div className="form-header">

                        <h3 className="form-title">

                          Solicitar Informações

                        </h3>

                        <button

                          className="btn-back"

                          onClick={() => setShowForm(false)}

                          title="Voltar"

                        >

                          ←

                        </button>

                      </div>

                      <form

                        className="contact-form"

                        onSubmit={submitForm}

                      >

                        <div className="form-group">

                          <label htmlFor="name">

                            Nome completo

                          </label>

                          <input

                            id="name"

                            name="name"

                            placeholder="Digite seu nome"

                            required

                            minLength="3"

                            maxLength="200"

                          />

                        </div>

                        <div className="form-group">

                          <label htmlFor="email">

                            E-mail

                          </label>

                          <input

                            id="email"

                            name="email"

                            type="email"

                            placeholder="seu@email.com"

                            required

                          />

                        </div>

                        <div className="form-group">

                          <label htmlFor="phone">

                            Telefone

                          </label>

                          <input

                            id="phone"

                            name="phone"

                            type="tel"

                            placeholder="(00) 00000-0000"

                            required

                          />

                        </div>

                        <button

                          type="submit"

                          className="btn btn-primary"

                        >

                          Enviar

                        </button>

                      </form>

                    </div>

                  </div>

                </div>

              </aside>

            </div>

          </div>

        </div>

      </main>

      <section className="section related-section">

        <div className="container">

          <div className="row mb-3 align-items-center">

            <div className="col-lg-6">

              <h2 className="font-weight-bold text-primary heading">

                Você também pode se interessar

              </h2>

            </div>

            <div className="col-lg-6 text-lg-end">

              <a

                href="#"

                className="btn btn-primary text-white py-3 px-4"

              >

                Ver todos os imóveis

              </a>

            </div>

          </div>

          <div className="related-empty">

            Nenhum imóvel similar disponível no momento.

          </div>

        </div>

      </section>

      {imageViewerOpen && (
        <div
          className="property-image-viewer"
          role="dialog"
          aria-modal="true"
          aria-label="Galeria de imagens do imóvel"
        >
          <button
            type="button"
            className="property-image-viewer__backdrop"
            aria-label="Fechar visualizador"
            onClick={() => setImageViewerOpen(false)}
          />

          <div className="property-image-viewer__counter">
            {activeImage + 1}/{property.images.length}
          </div>

          <button
            type="button"
            className="property-image-viewer__close"
            aria-label="Fechar visualizador"
            onClick={() => setImageViewerOpen(false)}
          >
            <span aria-hidden="true">×</span>
          </button>

          <button
            type="button"
            className="property-image-viewer__nav property-image-viewer__prev"
            aria-label="Imagem anterior"
            onClick={previousImage}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>

          <div className="property-image-viewer__stage">
            <img src={currentImage.src} alt={currentImage.alt} />
          </div>

          <button
            type="button"
            className="property-image-viewer__nav property-image-viewer__next"
            aria-label="Próxima imagem"
            onClick={nextImage}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>

          <div className="property-image-viewer__thumbnails" aria-label="Miniaturas das imagens">
            {property.images.map((image, index) => (
              <button
                type="button"
                key={image.src}
                className={`property-image-viewer__thumbnail ${index === activeImage ? "active" : ""}`}
                aria-label={`Abrir imagem ${index + 1}`}
                aria-current={index === activeImage ? "true" : undefined}
                onClick={() => setActiveImage(index)}
              >
                <img src={image.src} alt="" />
              </button>
            ))}
          </div>
        </div>
      )}

    </div>

  );

}

export default PropertySingle;
